// Form group
export default class FormGroup {
  constructor(item) {
    this.formItem = item;
    this.inputCharCounterClass = 'form-group__counter';
    this.inputContainer = '.form-group';

    this.initFormLogic();
  }

  // init form group methods
  initFormLogic = () => {
    this.addInputCounter(this.formItem);
  }

  setStringCount = (element, inputContainer, maxLength) => {
    const inputStringCounter = inputContainer.querySelector(`.${this.inputCharCounterClass}`);
    const stringLength = element.value.length;

    inputStringCounter.innerHTML = `${stringLength}/${maxLength}`;
  }

  // init input char counter
  addInputCounter = (element) => {
    const maxLength = element.getAttribute('maxlength');
    const inputContainer = element.closest(this.inputContainer);
    const infoContainer = inputContainer.querySelector('.form-group__info-container');

    infoContainer.insertAdjacentHTML('beforeend',
      `<p class="${this.inputCharCounterClass}">${element.value.length}/${maxLength}</p>`);

    element.addEventListener('keyup', () => {
      this.setStringCount(element, inputContainer, maxLength);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.input-text__input[maxlength]')) {
    document.querySelectorAll('.input-text__input[maxlength]').forEach(item => new FormGroup(item));
  }
});
